// /pages/LandingPage.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/LandingPage.css'; // CSSファイルをインポート
import { HiAcademicCap } from "react-icons/hi2";

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="all-container">
      <div className="header-container">
        <div className="logo">
          <img src="/images/default1.png" alt="Logo" />
          Ace Match
        </div>
        <button className="button-b" onClick={() => navigate('/login')}>ログイン</button>
      </div>

      <img src='/images/aaa.png' className='lp-top-img' alt="トップ画像" />

      <p className="description-text">
        ace match は<br></br>アセクシャルの方に向けたマッチングアプリです。<br></br>
        きめ細やかな検索機能や、デートの安全性を守るサポートで分かり合える出会いを提供します。
        <br></br>
        <span className='description-text-mini'>
          ※アセクシャル（デミセクシャル、グレイセクシャル含む）の方のみご利用いただけます。
        </span>
        <br></br>
        <strong style={{ color: 'red' }}>※現在準備中です。リリースまでしばらくお待ちください。</strong>
      </p>

      <div className="button-container-y">
        <button className="button-a disabled" disabled>はじめる（準備中）</button>
      </div>

      <div className="about-container">
        <p className="feature-top">Ace match<br></br>だからできること</p>

        <div>
          <p className="feature-content">１　きめ細やかな検索機能</p>
          <div className="feature-container">
            <p className="feature-text">
              性的指向・スキンシップの許容度などきめ細かく設定・検索できるから自分に合ったパートナーを見つけやすい。
            </p>
            <img src="/images/colab.png" alt="説明画像" className="feature-image" />
          </div>
        </div>

        <div>
          <p className="feature-content">２　安心・安全のサポート</p>
          <div className="feature-container">
            <p className="feature-text">
              年齢確認・違反報告・通報機能などを備えており、安心して利用できます。
            </p>
            <img src="/images/colab.png" alt="説明画像" className="feature-image" />
          </div>
        </div>

        <div>
          <p className="feature-content">３　豊富なプロフィール項目</p>
          <div className="feature-container">
            <p className="feature-text">
              スキンシップの希望、恋愛観、ライフスタイルなど詳細なプロフィールで自分らしさを表現できます。
            </p>
            <img src="/images/colab.png" alt="説明画像" className="feature-image" />
          </div>
        </div>
      </div>
      <div className="recommendation-slider">
        <h3 className="recommendation-title">使い方</h3>
        <div className="slider">
          <div className="slide">
            <img src="/images/couplex.jpeg" alt="Case 1" className="slide-image" />
            <h4 className="slide-title">① 恋人や友人が欲しい</h4>
            <p className="slide-description">
              「とりあえず恋人が欲しい人」から
              「今の内に将来の結婚相手を見つけたい」と考える人までそのキッカケを提供します。
            </p>
          </div>
          <div className="slide">
            <img src="/images/syakaizinx.jpeg" alt="Case 2" className="slide-image" />
            <h4 className="slide-title">② ラフに会話をしたい人</h4>
            <p className="slide-description">
              --------
            </p>
          </div>
        </div>
      </div>
      <br /><br /><br /><br /><br />

      <div className="button-container">
        <button className="button-a disabled" disabled>はじめてみる（準備中）</button>
      </div>

      <footer className="footer">
        <p className="footer-text">問い合わせ先：<br />e-mail：info　@ace-match.net</p>   
        <p className="footer-text">
          <Link to="/terms-of-service">利用規約</Link>
        </p>
        <p className="footer-text">
          <Link to="/privacy-policy">プライバシーポリシー</Link>
        </p>
        <p className="footer-text">&copy; 2025 Ace Match. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default LandingPage;
